import {idtype, linkTo, link, secondaryLink} from "querypieces";

export default `
  ...on pageBuilder_servicesApply_BlockType {
    ${idtype}
    heading
    plainText
    iconThings {
      ...on iconThingsItem_Entry {
        id
        icon {
          url
          ...on images_Asset {
            optimized: optimizedImage {
              placeholder: placeholderBox(color: "transparent")
            }
          }
        }
        heading
        text
      }
    }
    ${linkTo}
    ${secondaryLink}
  }
`;
